import React, { useState, useEffect } from "react";
import Recepients from "./Recepients";
import { EscrowContractAddress } from "../Services/EscrowContractAddress";
import { ethers } from "ethers";
import { Spinner } from "flowbite-react";
import { EthContracatAddress } from "../Services/EthContractAddress";
import { useSigner, useAccount, useNetwork } from "wagmi";
import { receivedTxByEvents } from "../Services/Moralis";

const ReceivedTransaction = () => {
  //----------------------useHook from wagmi-------------------------------------//
  const { chain } = useNetwork();
  const { data: signer } = useSigner();
  //------------------------STATES------------------------------------//

  const [data, setData] = useState([]);
  const [waiting, setWaiting] = useState(true);
  //--------------------USEEFFECT---------------------------//
  useEffect(() => {
    if (signer && chain) {
      if (window.ethereum) {
        window.ethereum.on("chainChanged", () => {
          if (signer) {
            getAllContracts(chain.id);
          }
        });
        window.ethereum.on("accountsChanged", () => {
          if (signer) {
            getAllContracts(chain.id);
          }
        });
      }

      getAllContracts(chain.id);
    }
  }, [signer, chain]);

  //-----------------,-----Contracts---------------------------------------------------//

  const getAllContracts = async (id, contractAddress, chain) => {
    if (id === 11155111) {
      try {
        setWaiting(true);
        setData("");

        signer.getAddress().then(async (res) => {
          receivedTxByEvents(res, "sepolia", EthContracatAddress).then(
            async (_res) => {
              setData(_res);
              setWaiting(false)
            }
          );
        });
      } catch (error) {
        console.log(error);
      }
    } else {

      try {
        setWaiting(true);
        setData("");

        signer.getAddress().then(async (res) => {
          receivedTxByEvents(res, "bsc%20testnet", EscrowContractAddress).then(
            async (_res) => {
              setData(_res)
              setWaiting(false);
            }
          );
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <div>
      <div className="p-8">
        <div className="    pt-10  ">
          <div className="md:flex md:gap-96 justify-between">
            <h1 className=" py-2 text-blue-400 pl-4">Received Transactions</h1>
          </div>
          <div className="">
            <div className=" grid grid-cols-4 gap-28 items-center px-4  ">
              <h1> Sender Address</h1>
              <h1 className=""> Amount</h1>
              <h1 className="-ml-6"> Date</h1>
            </div>

            {waiting ? (
              <div className=" p-8">
                <Spinner />
              </div>
            ) : (
              data &&
              data?.map((val) => {
                const amountEth = ethers.utils.formatEther(val.amount);
                

                return (
                  <Recepients
                    Sender={val.sender}
                    Receiver={val.receiver}
                    executedDate={val.date}
                    Amount={amountEth}
                  />
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceivedTransaction;
